import { render, staticRenderFns } from "./book.vue?vue&type=template&id=f73a3d5e&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports